import { createConnection, closeConnection, handleMessage } from "./actions";
import { websocketURL } from "../../utils/constants";

class SocketManager {
  socket: WebSocket | undefined;
  timeout: any;
  deviceId: { deviceId: number, uid: string};
  init(devId: { deviceId: number, uid: string}) {
    this.socket = new WebSocket(websocketURL);
    this.socket.onopen = this.onConnection;
    this.socket.onerror = this.onError;
    this.socket.onmessage = this.onMessage;
    this.socket.onclose = this.onClose;
    this.deviceId = devId;
  }

  onConnection = (event) => {
    createConnection();
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = undefined;
    }
    this.socket?.send(this.constructMessage("CREATE_SESSION", this.deviceId));
  }

  onError = (er) => {
    this.retryConnection();
  }

  onMessage = (msg) => handleMessage(JSON.parse(msg.data));

  onClose = (data) => {
    closeConnection();
    this.socket = undefined;
    this.retryConnection();
  }

  retryConnection() {
    if (this.socket) return;
    this.timeout = setTimeout(() => {
      this.init(this.deviceId);
    }, 2000);
  }

  send(type: string, payload: any = {}) {
    this.socket?.send(this.constructMessage(type, payload));
  }

  constructMessage(type: string, payload: any) {
    return JSON.stringify({
      type,
      payload,
    });
  }

  close() {
    this.socket?.close();
  }

  parse(data: string) {
    return JSON.parse(data);
  }
}

export const socketManager = new SocketManager();
